import React, { useCallback, useRef, useState } from 'react';
import { CONFIG } from 'config/config';

import Modal from '@material-ui/core/Modal';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { isMobile } from 'react-device-detect';
import { Button, Text, UiWrapper, View } from '@coinscrap/webapp-core';
import CloseButton from 'components/CloseButton/CloseButton';

// components
// configs
const TaxRegimeModal = ({ isOpen, onClose, children, onClick }) => {
	const faqRef = useRef();
	const { useBackground } = UiWrapper.use();
	useBackground(CONFIG.colors.white);
	const [isScroll, setIsScroll] = useState(false);
	const [buttonDisabled, setButtonDisabled] = useState(true);

	const observer = useRef();

	const lastPlanElementRef = useCallback(
		(node) => {
			if (observer.current) observer.current.disconnect();
			observer.current = new IntersectionObserver((entries) => {
				if (entries[entries.length - 1].isIntersecting) {
					setButtonDisabled(false);
					setIsScroll(false);
				} else {
					setIsScroll(true);
				}
			});
			if (node) observer.current.observe(node);
		},
		[observer],
	);

	return (
		<Modal open={isOpen} onClose={onClose} key={'terms_modal'} style={{ zIndex: 10000 }}>
			<View
				style={{
					backgroundColor: CONFIG.colors.white,
					overflowY: 'auto',
					width: '90vw',
					height: '80vh',
					marginTop: '5vh',
					marginLeft: '5vw',
				}}
			>
				<View fullHeightSt style={{ justifyContent: 'flex-start' }}>
					<View fullHeightSt justifyStartSt style={{ position: 'relative' }}>
						<View rowSt justifyEndSt style={{ marginTop: 10 }}>
							<CloseButton
								color={CONFIG.colors.primary}
								action={() => {
									onClose();
								}}
							/>
						</View>

						<View
							justifyStartSt
							style={{
								overflowY: 'scroll',
								height: 'calc(100% - 150px)',
								maxWidth: 850,
								padding: 10,
								width: '90%',
							}}
						>
							{children}
							<View>
								<Text
									headingPrimarySt
									style={{
										color: CONFIG.colors.primary,
										fontFamily: CONFIG.fonts.bold,
									}}
								>
									RÉGIMEN FISCAL APLICABLE
								</Text>

								<View style={{ paddingTop: 20, gap: '2rem' }}>
									<View style={{ gap: '0.5rem' }}>
										<Text policyDetailTitleSt>Legislación de aplicación</Text>
										<Text policyDetailDescriptionSt>
											Al producto de seguros Allianz Vida Riesgo Plus le es de
											aplicación la siguiente legislación y en su caso,
											aquellas modificaciones y adaptaciones de las mismas;
										</Text>

										<Text policyDetailDescriptionSt>
											Ley 50/1980, de 8 de octubre, de Contrato de Seguro.
										</Text>
										<Text policyDetailDescriptionSt>
											Ley 20/2015, de 14 de julio, de ordenación, supervisión
											y solvencia de las entidades aseguradoras y
											reaseguradoras (LOSSEAR).
										</Text>
										<Text policyDetailDescriptionSt>
											Real Decreto 1060/2015, de 20 de noviembre, de
											ordenación, supervisión y solvencia de las entidades
											aseguradoras y reaseguradoras(ROSSEAR)
										</Text>
										<Text policyDetailDescriptionSt>
											Real Decreto-ley 3/2020, de 4 de febrero, de medidas
											urgentes por el que se incorporan al ordenamiento
											jurídico español diversas directivas de la Unión Europea
											en el ámbito de la contratación pública en determinados
											sectores; de seguros privados; de planes y fondos de
											pensiones; del ámbito tributario y de litigios
											fiscales(IDD)
										</Text>
										<Text policyDetailDescriptionSt>
											Ley Orgánica 3/2018, de 5 de diciembre, de Protección de
											Datos Personales y garantía de los derechos digitales
											(LOPD).
										</Text>
										<Text policyDetailDescriptionSt>
											Real Decreto 304/2014, de 5 de mayo, por el que se
											aprueba el Reglamento de la Ley 10/2010, de 28 de abril,
											de prevención del blanqueo de capitales y de la
											financiación del terrorismo.
										</Text>
										<Text policyDetailDescriptionSt>
											Ley 22/2007, de 11 de julio, sobre comercialización a
											distancia de servicios financieros destinados a los
											consumidores.
										</Text>
									</View>
								</View>
							</View>
							<View ref={lastPlanElementRef} style={{ height: 10 }}>
								<View ref={faqRef} />
							</View>
						</View>

						<ArrowForwardIosIcon
							onClick={() => {
								faqRef.current.scrollIntoView({
									behavior: 'smooth',
								});
							}}
							style={{
								color: CONFIG.colors.primary,
								position: 'absolute',
								bottom: isMobile ? 25 : 30,
								right: 30,
								width: 45,
								height: 'auto',
								transform: 'rotate(90deg)',
								opacity: isScroll ? 1 : 0,
								cursor: 'pointer',
							}}
						></ArrowForwardIosIcon>
						<Button
							style={{ marginTop: 20 }}
							disabled={!!buttonDisabled}
							onClick={() => {
								onClose();
							}}
						>
							Aceptar
						</Button>
					</View>
				</View>
			</View>
		</Modal>
	);
};

export default TaxRegimeModal;
